module.exports = __webpack_public_path__ + "img/icon_square_pen_solid.b30aa3ed.svg";